export default __webpack_public_path__ + "static/media/pers2_sp.e1b4cc7c.jpg";